// extracted by mini-css-extract-plugin
export default {"container":"TechnographicsChat_container__mhfLF","title":"TechnographicsChat_title__jLbD0","subtitle":"TechnographicsChat_subtitle__DiR3v","list":"TechnographicsChat_list__x7qjn"};